<app-header [user]="user()" />

@if (successFullyRegistered()) {
  <div class="www-tha-you">
    <section class="www-tha-you__con">
      <div class="www-tha-you__con__red-cir" [appAnimate]="'fadeInRight'" delay="800"></div>
      <div class="www-tha-you__con__yel-cir" [appAnimate]="'fadeInLeft'" delay="900"></div>

      <img
        class="www-tha-you__con__img"
        alt="Woman"
        src="assets/images/pages/thank-you/woman.webp"
        [appAnimate]="'fadeInLeft'"
      />
      <div class="www-tha-you__con__text" [appAnimate]="'fadeInRight'">
        <h1 class="www-tha-you__con__text__tit f-open-sans">Witaj w <strong>PRO&middot;CONNECT</strong></h1>
        <p class="www-tha-you__con__text__des f-open-sans">
          Dziękujemy za aktywację konta i gratulujemy dołączenia do społeczności profesjonalistów, którzy wyznaczają
          nowe ścieżki w sztuce fryzjerskiej. PRO.CONNECT to miejsce stworzone z myślą o tych, którzy pragną sięgać
          dalej, rozwijać swoje talenty i wprowadzać innowacje do świata fryzjerstwa.​
          <br /><br />
          Wkrótce będziesz mógł odkryć pełnię możliwości, jakie oferujemy – od unikalnych szkoleń, przez ekskluzywne
          wydarzenia, po wsparcie, które pomoże Ci rozwinąć Twój salon na miarę Twoich ambicji. PRO.CONNECT to
          przestrzeń, w której każdy szczegół ma znaczenie, a każde doświadczenie wzbogaca Twoją zawodową podróż.​
          <br /><br />
          Otrzymasz od nas e-mail, gdy wszystko będzie gotowe, byś mógł w pełni zanurzyć się w świecie, który
          zaprojektowaliśmy z myślą o Twoim rozwoju.​ ​<br /><br />
          Do zobaczenia wkrótce!​
        </p>
      </div>
    </section>
  </div>
} @else {
  <div class="www-act-acc pb-5">
    <section class="www-act-acc__con">
      <form
        [formGroup]="formGroup"
        [ngxsFormClearOnDestroy]="_isBrowser"
        [ngxsFormDebounce]="20"
        [ngxsForm]="'activateAccount.form'"
        class="www-form www-act-acc__con__form"
        appInvalidControlScroll
        [appAnimate]="'fadeInLeft'"
        [speed]="'fast'"
      >
        <a
          class="www-act-acc__con__form__back"
          [routerLink]="['/' + WwwRouteSlug.LOGIN]"
          appGtmClick
          [layer]="{
            event: 'uaevent',
            ecommerce: 'undefined',
            eventCategory: 'activate account page',
            eventAction: 'select::go to login page',
            eventLabel: 'go to login page::' + '/' + WwwRouteSlug.LOGIN,
            event_name: 'body_button_click',
            module_name: 'go to login page',
            cta_name: 'go to login page',
            link_url: '/' + WwwRouteSlug.LOGIN,
          }"
          >< Powrót do ekranu logowania</a
        >
        <h3 class="www-act-acc__con__form__ti">Rejestracja</h3>

        <p class="www-act-acc__con__form__ste">
          Krok {{ currentStep() }}:
          @switch (currentStep()) {
            @case (1) {
              Weryfikacja danych działalności gospodarczej
            }
            @case (2) {
              Ustawianie danych kontaktowych
            }
            @case (3) {
              Zgody
            }
          }
        </p>

        <ul class="www-act-acc__con__form__dots list-unstyled">
          @for (s of steps(); let i = $index; track i) {
            <li
              class="www-act-acc__con__form__dots__dot"
              (click)="changeStepIfValid(i + 1)"
              [ngClass]="{ active: currentStep() === i + 1, done: steps()[i] }"
            >
              @if (s) {
                <svg xmlns="http://www.w3.org/2000/svg" width="6.478" height="4.831" viewBox="0 0 6.478 4.831">
                  <path
                    d="M2.2,9.313.095,7.208a.324.324,0,0,1,0-.458l.458-.458a.324.324,0,0,1,.458,0L2.429,7.71,5.467,4.672a.324.324,0,0,1,.458,0l.458.458a.324.324,0,0,1,0,.458L2.659,9.313A.324.324,0,0,1,2.2,9.313Z"
                    transform="translate(0 -4.577)"
                    fill="#f0f0f0"
                  />
                </svg>
              }
            </li>
          }
        </ul>

        @switch (currentStep()) {
          @case (1) {
            <div class="row">
              <div class="col-12">
                <div class="group">
                  <input
                    [appInputValidator]="f.firstname"
                    [formControlName]="'firstname'"
                    id="firstname"
                    type="text"
                    autocomplete="off"
                  />
                  <label for="firstname">Imię właściciela salonu</label>
                </div>
                <app-validate-message [control]="f.firstname" />
              </div>

              <div class="col-12">
                <div class="group">
                  <input
                    [appInputValidator]="f.lastname"
                    [formControlName]="'lastname'"
                    id="lastname"
                    type="text"
                    autocomplete="off"
                  />
                  <label for="lastname">Nazwisko właściciela salonu</label>
                </div>
                <app-validate-message [control]="f.lastname" />
              </div>

              <div class="col-12">
                <div class="group">
                  <input
                    class="used"
                    [value]="details()?.sap_code || '-'"
                    [disabled]="true"
                    id="sap_code"
                    nbInput
                    type="text"
                  />
                  <label class="label" for="sap_code">Kod Klienta L’Oréal</label>
                </div>
              </div>

              <div class="col-12">
                <div class="group">
                  <input class="used" [disabled]="true" [value]="details()?.nip || '-'" id="nip" type="text" />
                  <label for="nip">NIP</label>
                </div>
              </div>

              <div class="col-12">
                <div class="group">
                  <input class="used" [disabled]="true" [value]="details()?.street || '-'" id="street" type="text" />
                  <label for="street">Ulica</label>
                </div>
              </div>

              <div class="col-12">
                <div class="group">
                  <input
                    class="used"
                    [disabled]="true"
                    [value]="details()?.zip_code || '-'"
                    id="zip_code"
                    type="text"
                  />
                  <label for="zip_code">Kod pocztowy</label>
                </div>
              </div>

              <div class="col-12">
                <div class="group">
                  <input class="used" [disabled]="true" [value]="details()?.city || '-'" id="city" type="text" />
                  <label for="city">Miejscowość</label>
                </div>
              </div>

              <div class="col-12 www-act-acc__con__form__cor">
                <p class="www-act-acc__con__form__cor__p my-2">
                  <strong>UWAGA! Jeśli powyższe dane nie są poprawne, zaznacz poniższe.</strong>
                </p>
                <div>
                  <input type="checkbox" id="myDataAreValid" [formControlName]="'myDataAreValid'" />
                  <label for="myDataAreValid"
                    >Dane nie są poprawne. Skontaktujemy się z Tobą w celu aktualizacji danych.</label
                  >
                </div>

                <p class="www-act-acc__con__form__cor__reg">
                  <!-- Administratorem Pani/Pana danych osobowych jest L’Oréal Polska Sp. z o.o., z siedzibą w Warszawie
                  (00-844) przy ul. Grzybowskiej 62. Kontakt z Inspektorem Ochrony Danych możliwy jest za pośrednictwem
                  adresu e-mail: personal-da&#64;loreal.com. Przetwarzanie danych osobowych będzie się odbywać w
                  szczególności na podstawie umowy (art. 6 ust. 1 lit. b Ogólnego o Ochronie Danych Osobowych („RODO”) w
                  odniesieniu do czynności związanych z udziałem w Programie oraz korzystaniem z Platformy. Ma Pani/Pan
                  prawo żądania dostępu do swoich danych osobowych, prawo ich sprostowania, usunięcia lub żądania
                  ograniczenia przetwarzania, prawo do przenoszenia danych, a także prawo wniesienia sprzeciwu na ich
                  przetwarzanie, na zasadach i w przypadkach przewidzianych w przepisach RODO. Szczegółowe informacje
                  dotyczące przetwarzania danych osobowych zawarte są w
                  <a href="/assets/files/Regulamin PRO.CONNECT_2025.pdf" target="_blank"
                    >Regulaminie Programu i Platformy</a
                  >
                  oraz <a target="_blank" href="#">Polityce Prywatności.</a>.<br /> -->

                  Administratorem danych osobowych jest L’Oréal Polska Sp. z o.o., z siedzibą w Warszawie przy ul.
                  Grzybowskiej 62, 00-844 w Warszawie.
                  @if (!clouseExpanded()) {
                    <a class="exp" (click)="clouseExpanded.set(!clouseExpanded())">
                      {{ clouseExpanded() ? '[MNIEJ]' : '[WIĘCEJ]' }}</a
                    >
                  }
                  @if (clouseExpanded()) {
                    <div [appAnimate]="'landing'" [speed]="'faster'">
                      W sprawach przetwarzania danych osobowych i realizacji uprawnień, o których mowa poniżej możliwy
                      jest poprzez kontakt z Inspektorem Ochrony Danych w L’Oréal Polska pod adresem e-mail:
                      personal-da&#64;loreal.com.
                      <br /><br />
                      Dane osobowe będą przetwarzane w celach zorganizowania oraz obsługi Programu na podstawie art.6
                      ust.1 lit. b RODO, a także - w razie wyrażenia uprzedniej, przynajmniej jednej zgody na kontakt w
                      celach marketingu bezpośredniego – na podstawie z art. 6 ust. 1. lit. a RODO. W ramach realizacji
                      celu marketingu bezpośredniego dane mogą być wykorzystane w procesie profilowania, którego celem
                      jest jak najlepsze dopasowanie przesyłanych informacji do potrzeb i zainteresowań Uczestnika
                      Programu zgodnie z art. 6 ust. 1 lit. f RODO. Dane osobowe Uczestników Programu są przetwarzane
                      również, na podstawie art. 6 ust. 1 lit. c RODO, w celu realizacji obowiązków Administratora
                      wynikających z przepisów prawa, w tym przepisów podatkowych oraz w celu dochodzenia lub obrony
                      przed roszczeniami na podstawie art.6 ust.1 lit f RODO.
                      <br /><br />
                      Dane są przekazywane podmiotom przetwarzającym je na nasze zlecenie, w szczególności agencjom
                      marketingowym, podmiotom świadczącym usługi IT, usługi prawne bądź usługi podatkowe tylko w celu i
                      zakresie niezbędnym dla realizacji w/w celów. Przy czym takie podmioty przetwarzają dane na
                      podstawie umów zawartych z nami i wyłącznie zgodnie z naszymi poleceniami. Dane osobowe mogą być
                      także udostępniane podmiotom powiązanym z Administratorem oraz podmiotom do tego upoważnionym, na
                      podstawie przepisów prawa. Dane osobowe nie będą przekazywane do państwa trzeciego/organizacji
                      międzynarodowej. Dane osobowe będą przetwarzane przez okres trwania Programu, a także
                      przechowywane do momentu przedawnienia ewentualnych roszczeń lub wygaśnięcia obowiązku
                      archiwizacji danych wynikającego z przepisów prawa. Podmiotom danych przysługuje prawo dostępu,
                      sprostowania, usunięcia, wyrażenia sprzeciwu lub ograniczenia przetwarzania, a także prawo do
                      przenoszenia danych oraz prawo wycofania zgody na przetwarzanie danych w celach marketingowych.
                      Uczestnikowi Programu przysługuje prawo wniesienia skargi do Prezesa Urzędu Ochrony Danych
                      Osobowych, gdy uzna, iż przetwarzanie jego danych osobowych narusza przepisy RODO. Ponadto
                      dopuszczalna jest rezygnacja z Programu w dowolnym momencie. Więcej informacji o tym jak
                      przetwarzamy dane znajduje się w Polityce prywatności.
                      <br /><br />
                      Informujemy, że zgoda na przetwarzanie danych osobowych do wskazanych powyżej celów może zostać
                      wyrażona przez osobę, która ukończyła 16 lat.
                      <a class="exp" (click)="clouseExpanded.set(!clouseExpanded())">
                        {{ clouseExpanded() ? '[MNIEJ]' : '[WIĘCEJ]' }}</a
                      >
                    </div>
                  }
                </p>
              </div>
            </div>
          }
          @case (2) {
            <div class="row">
              <div class="col-12">
                <div class="group">
                  <input
                    [appInputValidator]="f.email"
                    [formControlName]="'email'"
                    id="email"
                    type="email"
                    autocomplete="off"
                  />
                  <label for="email">Podaj adres e-mail</label>
                </div>
                <app-validate-message [control]="f.email" />
              </div>

              <div class="col-12">
                <div class="group">
                  <input
                    [appInputValidator]="f.mobile"
                    [formControlName]="'mobile'"
                    id="mobile"
                    name="mobile"
                    type="text"
                    autocomplete="off"
                    [mask]="f.mobile.disabled ? null : '000 000 000'"
                    prefix="+48 "
                    [dropSpecialCharacters]="true"
                  />
                  <label for="mobile">Podaj numer telefonu komórkowego</label>
                </div>
                <app-validate-message [control]="f.mobile" />
              </div>

              <div class="col-12">
                <div
                  class="group"
                  [appShowPassword]="'assets/images/icon-remove-red-eye.svg'"
                  iAlt="Show password"
                  [iWidth]="'19'"
                  [iHeight]="'19'"
                >
                  <input
                    [appInputValidator]="f.password"
                    [formControlName]="'password'"
                    id="password"
                    type="password"
                  />
                  <label for="password">Ustaw hasło</label>
                </div>
                <app-validate-message [control]="f.password" />
              </div>

              <div class="col-12">
                <div
                  class="group"
                  [appShowPassword]="'assets/images/icon-remove-red-eye.svg'"
                  iAlt="Show password"
                  [iWidth]="'19'"
                  [iHeight]="'19'"
                >
                  <input
                    [appInputValidator]="f.repeatPassword"
                    [formControlName]="'repeatPassword'"
                    id="repeatPassword"
                    type="password"
                  />
                  <label for="password">Powtórz hasło</label>
                </div>
                <app-validate-message [control]="f.repeatPassword" />
              </div>

              <div class="col-12 www-act-acc__con__form__pass-req">
                <p class="www-act-acc__con__form__pass-req__p">Hasło powinno składać się z:</p>
                <ul class="www-act-acc__con__form__pass-req__ul">
                  <li>Co najmniej 8 znaków</li>
                  <li>liczby</li>
                  <li>znaku specjalnego</li>
                  <li>wielkiej litery</li>
                </ul>
              </div>
            </div>
          }
          @case (3) {
            <div class="row www-act-acc__con__form__con mb-lg-5 mb-4">
              <div class="col-12 mb-3">
                <p class="www-act-acc__con__form__con__p mb-4">Zgody</p>

                <div class="mb-1">
                  <div class="group">
                    <input type="checkbox" id="agreementProgram" [formControlName]="'agreementProgram'" />
                    <label for="agreementProgram">
                      <a href="/assets/files/Regulamin PRO.CONNECT_2025.pdf" target="_blank"
                        >Akceptuję regulamin platformy PRO.CONNECT</a
                      ><sup>*</sup></label
                    >
                  </div>

                  <app-validate-message [control]="f.agreementProgram" />
                </div>
              </div>
              <div class="col-12 mb-3">
                <p class="www-act-acc__con__form__con__des">
                  Wyrażam zgodę na kontakt przez L’Oréal Polska Sp. z o.o. z siedzibą w Warszawie (00-844 przy ul.
                  Grzybowskiej 62) w celu marketingu bezpośredniego, w tym przesyłania informacji handlowych, w
                  szczególności przesyłania informacji handlowych dotyczących produktów marek (L’Oréal Professionnel,
                  Kérastase, Matrix, Biolage, Redken) za pośrednictwem następujących kanałów komunikacji:
                </p>
              </div>
              <div class="col-12">
                <div>
                  <input type="checkbox" id="agreementEmail" [formControlName]="'agreementEmail'" />
                  <label class="small" for="agreementEmail">E-mail</label>
                </div>
                <app-validate-message [control]="f.agreementEmail" />
              </div>

              <div class="col-12">
                <div>
                  <input type="checkbox" id="agreementSms" [formControlName]="'agreementSms'" />
                  <label class="small" for="agreementSms">SMS</label>
                </div>
                <app-validate-message [control]="f.agreementSms" />
              </div>
              <div class="col-12">
                <div>
                  <input type="checkbox" id="agreementPhone" [formControlName]="'agreementPhone'" />
                  <label class="small" for="agreementPhone">Połączenie telefoniczne</label>
                </div>
                <app-validate-message [control]="f.agreementPhone" />
              </div>
              <div class="col-12">
                <div>
                  <input type="checkbox" id="agreementWhatsApp" [formControlName]="'agreementWhatsApp'" />
                  <label class="small" for="agreementWhatsApp">Whatsapp</label>
                </div>
                <app-validate-message [control]="f.agreementWhatsApp" />
              </div>
              <div class="col-12 mb-3">
                <small class="small">*pole obowiązkowe</small>
              </div>

              <div class="col-12">
                <p class="www-act-acc__con__form__con__des">
                  Administratorem Pani/Pana danych osobowych jest L’Oréal Polska Sp. z o.o., z siedzibą w Warszawie
                  (00-844) przy ul. Grzybowskiej 62. Kontakt z Inspektorem Ochrony Danych możliwy jest za pośrednictwem
                  adresu e-mail: personal-da&#64;loreal.com. Szczegółowe informacje dotyczące przetwarzania danych
                  osobowych zawarte są w <a target="_blank" href="#">Polityce Prywatności.</a>.
                </p>
              </div>
            </div>
          }
        }

        <div class="row www-act-acc__btn my-4 my-md-0">
          <div class="col-12">
            <button (click)="onRegister()" class="www-black-btn w-100">
              @if (currentStep() === steps().length) {
                Aktywuj swoje konto PRO.Connect!
              } @else {
                Przejdź dalej
              }
            </button>
          </div>
        </div>
      </form>

      <div class="www-act-acc__con__rig">
        <picture>
          <source media="(max-width:402px)" srcset="assets/images/pages/activate-account/activate-top-image-mb.webp" />
          <img
            class="www-act-acc__con__rig__img h-auto"
            [priority]="true"
            alt="background"
            ngSrc="assets/images/pages/activate-account/activate-top-image-ds.webp"
            [fill]="true"
          />
        </picture>
      </div>
    </section>
  </div>
}
